import { render, staticRenderFns } from "./StaffPictureEditor.vue?vue&type=template&id=3c7956b8&scoped=true"
import script from "./StaffPictureEditor.vue?vue&type=script&lang=js"
export * from "./StaffPictureEditor.vue?vue&type=script&lang=js"
import style0 from "./StaffPictureEditor.vue?vue&type=style&index=0&id=3c7956b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7956b8",
  null
  
)

export default component.exports